import React, { useState, useEffect, useContext } from "react";
import ModelContext from "../ModelContext";

export const IntroSection = (props) => {
    const modelCtx = useContext(ModelContext);

    return (
        <>
            <div className="row justify-content-center">
                <div className="col-12 bg-blue descriptions">
                    <div className="box">
                        <p className="color-white">
                            <span className="title1 wow fadeInUp" data-wow-delay="0.4s">{props.title}</span>
                            <br /><br />
                            <span className="title2-freeland wow fadeInUp" data-wow-delay="0.1s">
                                {props.subtitle}
                            </span>
                        </p>
                    </div>
                </div>
            </div>
            <div className="row">
                <p>&nbsp;</p>
            </div>
        </>
    );
};

export default IntroSection;
